import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import FormElement from 'components/FormElement';
import DpSwVersion from 'containers/testResult/DpSwVersion';
import { testResults } from 'dictionaries/TestResults';
import {
  isResultNoTesting,
  getTestResultTitle
} from 'helpers/RequestTestsHelper';
import { toMomentDate } from 'helpers/DateHelper';
import { makeEvent } from 'libs/form';
// import {
//   prepareLabOptions,
//   selectedLabsAsArray
// } from 'helpers/FormHelper';
import {
  changeTestField,
  changeTestDate,
  changeTestMultiField
} from 'actions/tests';
import { handleInputChange } from 'actions/request';
import { fetchAuthorizedLabs } from 'actions/labs';

class LabResultForm extends Component {
  componentDidMount() {
    const { testModule, fetchAuthorizedLabs, changeTestField } = this.props;

    fetchAuthorizedLabs();

    // replace planversion value with alias
    const planAlias = testModule.planversionAlias.trim();
    const syntEvent = makeEvent('planversion', planAlias);
    changeTestField(testModule.id, syntEvent);
  }

  onResultChange = event => {
    const result = Number(event.target.value);
    const hideUploads = isResultNoTesting(result);

    this.props.handleTestResult(hideUploads);
    this.props.changeTestField(this.props.testModule.id, event);
  };

  render() {
    const {
      labs,
      show,
      request,
      testModule,
      changeTestDate,
      changeTestField,
      handleInputChange,
      changeTestMultiField
    } = this.props;

    if (!show || !labs) return null;

    const { fccId, hwVersion, swVersion } = request;
    const {
      lab,
      planversion,
      actualenddate,
      actualstartdate,
      requesttestpassedstatusid,
      requestteststatusid
      // requesttestconductinglabs
    } = testModule;

    const noTesting = isResultNoTesting(requesttestpassedstatusid);
    const startDate = toMomentDate(actualstartdate);
    const endDate = toMomentDate(actualenddate);
    const fccInputType = request.isEco ? null : 'text';
    const fccInputValue = request.isEco
      ? fccId && fccId !== ''
        ? fccId
        : 'Not assigned'
      : fccId;
    // const labList = prepareLabOptions(labs);
    // const selectedLabs = selectedLabsAsArray(requesttestconductinglabs);

    return (
      <div>
        {/* <Bubble>
          Select the lab(s) that conducted the test. To select more than one
          lab, hold the <strong>Ctrl</strong> key while clicking.
        </Bubble> */}
        <Form horizontal>
          <FormElement
            id="testStatus"
            label="Test Status"
            value={getTestResultTitle(requestteststatusid)}
          />
          <FormElement
            // type="select"
            id="requesttestconductinglabs"
            label="Lab"
            // value={selectedLabs}
            value={lab.name}
            onChange={changeTestMultiField.bind(this, testModule.id)}
            // options={labList}
            // multiple={true}
          />
          <FormElement
            type="select"
            id="requesttestpassedstatusid"
            label="Test Result"
            value={requesttestpassedstatusid}
            onChange={this.onResultChange.bind(this)}
            options={testResults}
          />
          <FormElement
            type="text"
            id="planversion"
            label="Test Plan Version"
            value={planversion}
            onChange={changeTestField.bind(this, testModule.id)}
            placeholder="Enter version number"
            maxLength="50"
          />
          <FormElement
            type={fccInputType}
            id="fccId"
            label="FCC ID"
            value={fccInputValue}
            onChange={handleInputChange}
            placeholder="Enter FCC ID of the tested device"
            maxLength="50"
          />
          <FormElement
            type="text"
            id="hwVersion"
            label="Hardware Version"
            value={hwVersion}
            onChange={handleInputChange}
            placeholder="Enter the final tested hardware version"
            maxLength="50"
          />
          <FormElement
            type="text"
            id="swVersion"
            label="Software Version"
            value={swVersion}
            onChange={handleInputChange}
            placeholder="Enter the final tested software version"
            maxLength="50"
          />
          <DpSwVersion labMode={true} />
          <FormElement
            type="date"
            id="actualstartdate"
            label="Test Start Date"
            value={startDate}
            onChange={changeTestDate.bind(
              this,
              testModule.id,
              'actualstartdate'
            )}
            show={!noTesting}
          />
          <FormElement
            type="date"
            id="actualenddate"
            label="Test End Date"
            value={endDate}
            onChange={changeTestDate.bind(this, testModule.id, 'actualenddate')}
            show={!noTesting}
            minDate={startDate}
          />
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ request, tests, labs }) {
  return { request, tests, labs };
}

export default connect(
  mapStateToProps,
  {
    changeTestDate,
    changeTestField,
    changeTestMultiField,
    handleInputChange,
    fetchAuthorizedLabs
  }
)(LabResultForm);



// WEBPACK FOOTER //
// ./src/containers/testResult/LabResultForm.js